import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';

import { ResponseService } from '../../services/response.service';
import { IS_SERVER } from '../../providers/is-platform.provider';
import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonComponent } from '../button/button.component';
import { RouterLink } from '@angular/router';
import { AddLocalePipe } from '../../pipes/url-locale.pipe';

@Component({
  selector: 'app-not-found-content',
  imports: [TranslocoDirective, ButtonComponent, RouterLink, AddLocalePipe],
  templateUrl: './not-found-content.component.html',
  styleUrls: ['./not-found-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundContentComponent {
  constructor(@Inject(IS_SERVER) isServer: boolean, response: ResponseService) {
    if (isServer) {
      response.set404();
    }
  }
}
